export default __webpack_public_path__ + "static/media/loader.b2198a13.gif";